import { Paper, useMediaQuery } from '@mui/material';
import QR from '../../static/hopkinsrto_qr.jpg';
import DesktopLogo from '../../static/desktop/hopkinsrto_logo.jpg';
import MobileLogo from '../../static/mobile/hopkinsrto_logo.png';

const RTOHopkinsCard = () => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const logo = isMobile ? MobileLogo : DesktopLogo;
  const logoStyle = isMobile ? { width: '350px', height: 'auto' } : { height: 'auto' };

  return (
    <Paper
    sx={{
        backgroundColor: '#F8F5EB',
        borderTop: 3,
        borderColor: 'divider',
        padding: '0.5em',
        margin: '1.5em 0',
        width: '100%',
        maxWidth: '800px'
    }}>
      <a href='https://rtostreamline.com/mobile/Trailersrenttoown/default.aspx?dealer_id=53&location_id=263'>
        <img
        src={logo}
        alt="Hopkins RTO logo"
        style={logoStyle} />
      </a>

      <ul id='finance-app-list'>
        <li>or.. Scan our QR code
            <br></br>
            <img
            src={QR}
            alt="qr code for hopkins finance"
            width={'200px'} />
        </li>
      </ul>

    </Paper>
  )
}

export default RTOHopkinsCard;